import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PATH_NAME } from './Pathname';
import Login from '../Screens/Auth/Login';
import AuthGuard from '../Guards/AuthGuard';
import Dashboard from '../Screens/Dashboard/Dashboard';
import SignUp from '../Screens/Auth/SignUp';
import VerificationLink from '../Screens/Auth/VerificationLink';
import ForgetPassword from '../Screens/Auth/ForgetPassword';
import ReportingSentiments from '../Screens/Reporting/ReportingSentiments';
import ReportingContextInsights from '../Screens/Reporting/ReportingContextInsights';
import IssuesRaised from '../Screens/Issues/IssuesRaised';
import EmployeesList from '../Screens/Employees/EmployeesList';
import AddEditEmployee from '../Screens/Employees/AddEditEmployee';
import CampaignList from '../Screens/Campaign/CampaignList';
import EditCampaign from '../Screens/Campaign/EditCampaign';
import LeadingTurnover from '../Screens/LeadingTurnover/LeadingTurnover';
import Integration from '../Screens/Integration/Integration';
import FeedbackCall from '../Screens/Feedback/FeedbackCall';
import CallRecordings from '../Screens/Recordings/CallRecordings';
import CampaignDetails from '../Screens/Campaign/CampaignDetails';
import CriticalRisks from '../Screens/CriticalRisks/CriticalRisks';
import Settings from '../Screens/Settings/Settings';
import SchedulingCampaignExternal from '../Screens/Campaign/Components/SchedulingCampaignExternal';
import { SIGN_UP_FLOW } from '../Utils/helper/AppConstants';
import EmployeeDetailsContainer from '../Screens/Employees/EmployeeDetailsContainer';
import MoodInsights from '../Screens/Reporting/MoodInsights';
import CampaignInsights from '../Screens/Reporting/CampaignInsights';
import ActionableInsights from '../Screens/Reporting/ActionableInsights';
import ComingSoon from '../Screens/ComingSoon/ComingSoon';
import AlertCall from '../Screens/Recordings/AlertCall';
import NotFound from '../Screens/NotFound/NotFound';
import Support from '../Screens/Support/Support';
import Subscription from '../Screens/Subscription/Subscription';
import InboundCallList from '../Screens/Inbound/InboundCallList';
import InboundLayout from '../Screens/Inbound/InboundCall/InboundLayout';
import { StartYourCall } from '../Screens/Inbound/InboundCall/Components/StartYourCall';
import { CallProcessFlow } from '../Screens/Inbound/InboundCall/Components/CallProcessFlow/CallProcessFlow';
import AgentsList from '../Screens/Agents/AgentList';
import ExitInterviewDashboard from '../Screens/ExitInterviewDashBoard/ExitInterviewDashboard';

export default function AppRoutes() {
	return (
		<Suspense fallback={<div />}>
			<React.Fragment>
				<Routes>
					{/* external routes */}
					<Route path={PATH_NAME.FEEDBACK_CALL} element={<FeedbackCall />} />
					<Route path={PATH_NAME.ROOT} element={<Navigate to={PATH_NAME.DASHBOARD} />} />
					<Route path={PATH_NAME.LOGIN} element={<Login />} />
					{SIGN_UP_FLOW && (
						<>
							<Route path={PATH_NAME.SIGNUP} element={<SignUp />} />
							<Route path={PATH_NAME.VERIFICATION_LINK} element={<VerificationLink />} />
							<Route path={PATH_NAME.FORGET_PASSWORD} element={<ForgetPassword />} />
						</>
					)}
					<Route path={PATH_NAME.CAMPAIGN_SCHEDULING} element={<SchedulingCampaignExternal />} />

					{/* Public Inbound Routes */}

					<Route path={PATH_NAME.PUBLIC_INBOUND} element={<InboundLayout />}>
						<Route index element={<StartYourCall />} />
						<Route path="call" element={<CallProcessFlow />} />
					</Route>

					<Route element={<AuthGuard />}>
						<Route path={PATH_NAME.DASHBOARD} element={<Dashboard />} />
						<Route path={PATH_NAME.ACTIONABLE_INSIGHTS} element={<ActionableInsights />} />
						<Route path={PATH_NAME.REPORTING_INSIGHTS} element={<ReportingContextInsights />} />
						<Route path={PATH_NAME.MOOD_INSIGHTS} element={<MoodInsights />} />
						<Route path={PATH_NAME.CAMPAIGN_INSIGHTS} element={<CampaignInsights />} />
						<Route path={PATH_NAME.CAMPAIGN_ALERT} element={<AlertCall />} />
						<Route path={PATH_NAME.REPORTING_SENTIMENTS} element={<ReportingSentiments />} />

						<Route path={PATH_NAME.ISSUES_RAISED} element={<IssuesRaised />} />
						<Route path={PATH_NAME.EMPLOYEES_LIST} element={<EmployeesList />} />
						<Route path={PATH_NAME.EMPLOYEE_ADD} element={<AddEditEmployee />} />
						<Route path={PATH_NAME.EMPLOYEE_EDIT} element={<AddEditEmployee />} />
						<Route path={PATH_NAME.EMPLOYEE_DETAILS} element={<EmployeeDetailsContainer />} />
						<Route path={PATH_NAME.CRITICAL_RISK} element={<CriticalRisks />} />
						<Route path={PATH_NAME.CAMPAIGN_LIST} element={<CampaignList />} />
						<Route path={PATH_NAME.CAMPAIGN_DETAILS} element={<CampaignDetails />} />

						<Route path={PATH_NAME.CAMPAIGN_CREATE} element={<EditCampaign />} />
						<Route path={PATH_NAME.CAMPAIGN_EDIT} element={<EditCampaign />} />
						<Route path={PATH_NAME.CAMPAIGN_COPY} element={<EditCampaign />} />
						<Route path={PATH_NAME.LEADING_TURNOVER} element={<LeadingTurnover />} />
						<Route path={PATH_NAME.INTEGRATION} element={<Integration />} />
						<Route path={PATH_NAME.CONVERSATIONS} element={<CallRecordings />} />
						<Route path={PATH_NAME.SETTINGS} element={<Settings />} />
						<Route path={PATH_NAME.SUPPORT} element={<Support />} />
						<Route path={PATH_NAME.SUBSCRIPTION} element={<Subscription/>} />
						<Route path={PATH_NAME.INBOUND_CALL_LIST} element={<InboundCallList />} />
						<Route path={PATH_NAME.AGENTS_LIST} element={<AgentsList />} />
						<Route path={PATH_NAME.EXIT_INTERVIEW_DASHBOARD} element={<ExitInterviewDashboard />} />
						<Route path={PATH_NAME.COMING_SOON} element={<ComingSoon />} />
					</Route>
					<Route path="*" element={<NotFound />} />
				</Routes>
			</React.Fragment>
		</Suspense>
	);
}
